import React, { useImperativeHandle, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

//import theme from '@ecp/common/src/style/theme/default';
import { FlexBoxCenter } from '@ecp/common/src/layouts/flex/styled';
import FileUploaderUnstyled from '@ecp/common/src/components/unstyled/input/FileUploaderUnstyled';
import { EmptyCard } from '@ecp/common/src/components/file/ImageCard';

const UploaderDropzone = React.forwardRef(({ onChange, ...props }, ref) => {
  const fileUploaderRef = useRef(null);
  useImperativeHandle(ref, () => fileUploaderRef.current);

  return (
    <FileUploaderUnstyled
      dragdrop
      rootComponent={StyledFileUploaderRoot}
      dropzoneComponent={DefaultDropzoneComponent}
      buttonComponent={<EmptyCard />}
      multiple
      onChange={onChange}
      ref={fileUploaderRef}
      {...props}
    />
  );
});

const StyledFileUploaderRoot = styled.div`
  position: relative;
`;

const DefaultDropzoneComponent = styled(FlexBoxCenter)`
  width: 70px;
  height: 70px;
  border: 1px solid #dddddd;
  background-color: ${(props) => props.theme.color.background.white};
  border-radius: ${(props) => props.theme.component.imageFileUploader.borderRadius};
`;

UploaderDropzone.propTypes = {
  onChange: PropTypes.func,
};

UploaderDropzone.displayName = 'UploaderDropzone';

export default UploaderDropzone;
